// extracted by mini-css-extract-plugin
export var infoRow = "_tq-2";
export var labelContainer = "_tq-0";
export var rightInfo = "_tq-1";